import React from 'react';
import PropTypes from 'prop-types';

export class VerifiedCallerIdFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: props.filter || '',
      filterValid: true,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmitFilter('q', this.state.filter);
  };

  render() {
    const { filter } = this.state;

    return (
      <div className="phone-inventory-filter">
        {/* <div className="filter-search">
          <form onSubmit={this.handleSubmit}>
            <div className="search-input-wrapper">
              <i className="la la-search search-icon"></i>
              <input
                type="text"
                className="search-input"
                placeholder="Search numbers..."
                value={filter}
                onChange={(e) => this.setState({ filter: e.target.value })}
              />
            </div>
          </form>
        </div> */}

        {this.props.onAddVerifiedCallerId && (
          <button
            className="btn linear-gradient yr-submitbtn"
            onClick={this.props.onAddVerifiedCallerId}
          >
            <i className="la la-plus"></i>
            Add Verified Caller ID
          </button>
        )}
      </div>
    );
  }
}

VerifiedCallerIdFilter.propTypes = {
  onSubmitFilter: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  totalCount: PropTypes.number,
  onAddVerifiedCallerId: PropTypes.func,
};
